import { handleActions, combineActions } from 'redux-actions'
import { Record, Map, List } from 'immutable'

import * as actions from './actions'

export const OrgLabels = Record({
  items: List(),
  isPending: false,
})

const handleRequest = state => {
  return state.set('isPending', true)
}

const handleFetchSuccess = (state, { payload: { data } }) => {
  return state.set('items', List(data.map(el => Map(el)))).set('isPending', false)
}

const handlePostSuccess = (state, { payload: { data } }) => {
  return state.set('items', state.get('items').push(Map(data))).set('isPending', false)
}

const handlePutSuccess = (state, { payload: { data } }) => {
  const index = state.get('items').findIndex(el => el.get('id') === data.id)
  return state.setIn(['items', index], Map(data)).set('isPending', false)
}

const handleDeleteSuccess = (state, { meta: { labelId } }) => {
  const index = state.get('items').findIndex(el => el.get('id') === labelId)
  return state.deleteIn(['items', index]).set('isPending', false)
}

const handleFail = state => {
  return state.set('isPending', false)
}

export default handleActions(
  {
    [combineActions(actions.fetchOrgLabels, actions.createOrgLabel, actions.updateOrgLabel, actions.deleteOrgLabel)]:
      handleRequest,
    [combineActions(
      actions.fetchOrgLabels.fail,
      actions.createOrgLabel.fail,
      actions.updateOrgLabel.fail,
      actions.deleteOrgLabel.fail
    )]: handleFail,
    [actions.fetchOrgLabels.success]: handleFetchSuccess,
    [actions.createOrgLabel.success]: handlePostSuccess,
    [actions.updateOrgLabel.success]: handlePutSuccess,
    [actions.deleteOrgLabel.success]: handleDeleteSuccess,
  },
  new OrgLabels()
)
